import React from 'react';
import PropTypes from 'prop-types';
import ChannelSoft from './ChannelSoft';
import CallCenter from './CallCenter';
import { withApi } from '@tencent/react-aio';
import { connect } from 'react-redux';
import * as ActionTypes from '@/stores/sale/actions';
import _ from 'lodash';
import MessageBox from '@/components/MessageBox';
import DialOutModal from './DialOutModal';
import QiDian from './QiDian/index';
import message from '@/utils/message';
import { Dialog } from '@tencent/spaui';
import dayjs from 'dayjs';
import Decorate from '@tencent/spaui-decorate';
import DialIn from './DialInModal/dialIn';
import IdDetailDialog from './IdDetailDialog/index';
import IdDetailDialogStore from './IdDetailDialog/store';

const pageProps = window.pageProps;

function installScript(id, src) {
  return new Promise((resolve, reject) => {
    let ccScriptEl = document.getElementById(id);
    if (ccScriptEl) {
      resolve(ccScriptEl);
    } else {
      ccScriptEl = document.createElement('SCRIPT');
      ccScriptEl.id = id;
      ccScriptEl.src = src;
      ccScriptEl.defer = true;
      ccScriptEl.onload = ccScriptEl.onreadystatechange = () => {
        if (!ccScriptEl.readyState || /complete|loaded/.test(ccScriptEl.readyState)) {
          resolve();
        }
      };
      ccScriptEl.onerror = reject;
      document.body.appendChild(ccScriptEl);
    }
  });
}

class CallCenterDock extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    loginStatus: PropTypes.object.isRequired,
    updateCallCenter: PropTypes.func.isRequired,
  }

  state = { qdAgentBar: false, show: false, vendor: null, showIdDialogInfo: {} };

  // 呼入弹框缓存
  dialInModalList = {}

  componentDidMount() {
    const { webApi, loginStatus } = this.props;
    const { callCenter } = loginStatus;
    if (callCenter) {
      if (callCenter.startsWith('CHANNELSOFT:')) {
        this.initChannelSoft(loginStatus, webApi);
      } else if (callCenter.startsWith('QIDIAN:')) {
        this.setState({ qdAgentBar: true });
        // this.initQD(loginStatus, webApi)
      } else if (callCenter.startsWith('NO:')) {
        console.log('放弃加载电话呼叫面板：该用户未配置呼叫中心或坐席');
      } else if (callCenter.startsWith('ERROR:')) {
        message.error(`放弃加载电话呼叫面板， 该用户的坐席有误：${callCenter.substr('ERROR:'.length)}`);
      } else {
        message.error('电话呼叫面板加载错误， 未知的呼叫中心类型');
      }
    } else {
      console.warn('放弃加载电话呼叫面板：后端未提供呼叫中心配置');
    }
  }

  initChannelSoft(loginStatus, webApi) {
    const conf = _.find(pageProps.callCenter, (cc) => cc.vendor === 'CALL_CENTER_VENDOR_CHANNELSOFT');
    if (!conf) {
      throw new Error('Unable to find callCenter for ChannelSoft.');
    }

    installScript('cc_channelSoft', loginStatus.callCenterEntryJs || conf.entryJs).then(
      () => {
        if (window.WA) {
          const vendor = new ChannelSoft(window.WA, conf.isCallTelWithExt);
          this.callCenter = new CallCenter(webApi, vendor);

          // 显示呼出的界面
          this.callCenter.onDialOut((params, resp, makeCall, leadDetail) => {
            this.setState({
              dialOutInfo: { params, resp, makeCall, leadDetail },
            });
          });

          this.callCenter.onUpdateStatus((status, event) => {
            const waEl = document.getElementById('WA');
            if (waEl) {
              waEl.className = `online_${status}`;
            }
            this.props.updateCallCenter(this.callCenter, status, event);
          });

          // 初始化呼叫中心
          this.callCenter.init(loginStatus);

          this.props.updateCallCenter(this.callCenter, false, {});

          this.callCenter.login();
        }
      },
      (error) => {
        message.error(
          '加载电话呼叫面板失败',
          <span>
            请刷新页面重试；如果反复尝试依然不行，请联系管理员
            <hr />
            呼叫中心供应商：青牛 (ChannelSoft)
            <br />
            问题脚本地址：{error.target && error.target.src}
          </span>,
        );
      },
    );
  }

  initQD(loginStatus, webApi) {
    const conf = _.find(pageProps.callCenter, (cc) => cc.vendor === 'CALL_CENTER_VENDOR_QIDIAN');
    if (!conf) {
      throw new Error('Unable to find callCenter for ChannelSoft.');
    }

    // webApi.getJsTicket call-center/jsticket
    // webApi.getAgency agency
    // webApi.getCurrentEmployeeUser /ags/employee/current
    Promise.all([webApi.getJsTicket().ajax(), webApi.getAgency(loginStatus.agencyId).ajax(), webApi.getCurrentEmployeeUser().ajax(), installScript('qdAgentbar', loginStatus.callCenterEntryJs || conf.entryJs)])
      .then(([ticketRes, agencyInfoRes, employUserRes]) => {
        const { ticket } = ticketRes.data || {};
        const { callCenterId, seatNo, seatPreferredPhone } = employUserRes || {};
        const currentCallCenter = agencyInfoRes?.callCenterList?.find((item) => item.callCenterId === callCenterId) || {};

        const info = {
          appId: currentCallCenter.externalId,
          kfext: seatNo,
          ticket,
          seatPreferredPhone,
        };

        if (window.qd) {
          const vendor = new QiDian(window.qd, info);
          this.callCenter = new CallCenter(webApi, vendor);

          // 显示呼出的界面
          this.callCenter.onDialOut((params, resp, makeCall, leadDetail) => {
            this.setState({
              dialOutInfo: { params, resp, makeCall, leadDetail },
            });
          });

          this.callCenter.onUpdateStatus((status, event) => {
            const qdAgentbarEle = document.getElementById('qd-agentbar');
            if (qdAgentbarEle) {
              qdAgentbarEle.className = `online_${status}`;
            }
            this.props.updateCallCenter(this.callCenter, status, event);
            if (status) {
              this.handleClose();
              this.setState({ qdAgentBar: false, vendor: 'CALL_CENTER_VENDOR_QIDIAN' });
              console.log('呼叫中心初始化成功');
            }
            this.setState({ disabled: false });
          });

          this.callCenter.onDialIn(this.handleDialInInfo);
          // 初始化呼叫中心
          this.callCenter.init(loginStatus);

          this.props.updateCallCenter(this.callCenter, false, {});

          this.callCenter.login();
        }
      })
      .catch((error) => {
        message.error(
          '加载电话呼叫面板失败',
          <span>
            请刷新页面重试；如果反复尝试依然不行，请联系管理员 {error.message}
            <hr />
            呼叫中心供应商：企点
            <br />
            问题脚本地址：{loginStatus.callCenterEntryJs || conf.entryJs}
          </span>,
        );
      });
  }

  handleQdLogin = () => {
    this.setState({ show: true });
  }

  handleSubmit = () => {
    const { webApi, loginStatus } = this.props;
    this.setState({ disabled: true });
    this.initQD(loginStatus, webApi);
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  renderQdAgentBar = () => {
    return <div onClick={this.handleQdLogin} className="qd-agent-btn"></div>;
  }

  handleDialIn = () => {
    this.callCenter.handleDialIn();
  }

  render() {
    const { dialOutInfo, qdAgentBar, show, disabled } = this.state;
    let TempoComponent = () => <div/>;
    if (qdAgentBar) {
      TempoComponent = () => (
        <React.Fragment>
          {this.renderQdAgentBar()}
          <Dialog useNewUI disabled={disabled} style={{ width: 448 }} show={show} hideScrollBar={false} onClose={this.handleClose} onSubmit={this.handleSubmit} onCancel={this.handleClose} title="登录">
            点击确认登录呼叫中心
          </Dialog>
        </React.Fragment>
      );
    }
    if (dialOutInfo && dialOutInfo.resp) {
      TempoComponent = () => (
        <DialOutModal
          leadDetail={dialOutInfo.leadDetail}
          params={dialOutInfo.params}
          {...dialOutInfo.resp}
          contactPhone={dialOutInfo.params.contactPhone}
          makeCall={(id, showIdDialogInfo) => {
            dialOutInfo.makeCall(id);
            IdDetailDialogStore.changeIdDialogInfo({ ...showIdDialogInfo });
          }}
          onClose={this.handleCloseDialOutModal}
        />
      );
    }

    return (
      <div>
        <TempoComponent/>
        <IdDetailDialog/>
      </div>
    );
  }

  handleCloseDialOutModal = () => {
    const { mode } = this.state.dialOutInfo.params;
    // 关闭 DialOutModal 对话框
    this.setState({
      dialOutInfo: undefined,
    });
    // 关闭后检查是否需要弹出拨号面板，如果是手工拨出则弹出
    if (mode === 'manual') {
      this.callCenter.autoShowPanel();
    }
    setTimeout(() => {
      document?.body?.classList?.remove?.('dragging');
    });
  }

  handleDialInInfo = (params = {}, page = {}) => {
    // 非直销呼入禁止弹屏
    const { whiteList, loginStatus } = this.props;
    if(!_.includes(whiteList.data, loginStatus.agencyId)) return;
    // switchboardNumber(B侧总机号码)
    const { Caller, Callee, CallId, switchboardNumber, isAnswered, CallTime } = params;
    const { webApi } = this.props;
    let dialog = this.dialInModalList[Caller];
    const dialProps = {
      Caller,
      params: {
        Caller,
        Callee: switchboardNumber,
        CallId,
        isAnswered,
        vendor: this.state.vendor,
        CallTime: this.handleDialInTime(CallTime),
        _CallTime: CallTime,
      },
      whiteList,
      webApi,
      handleDialIn: this.handleDialIn,
    };
    if (dialog) {
      dialog.setProps({
        onClose: this.dialInModalDestory,
        ...dialProps,
      });
    } else {
      dialog = new Decorate(DialIn);
      this.dialInModalList[Caller] = dialog;
      dialog.setProps({
        onClose: this.dialInModalDestory,
        ...dialProps,
      });
    }
  }

  // 格式化呼入时间
  handleDialInTime = (time) => {
    if (time) {
      time = Math.floor(time * 1000);
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    }
    return dayjs().format('YYYY-MM-DD HH:mm:ss');
  }

  // 清空呼入弹框
  dialInModalDestory = (Caller) => {
    if (this.dialInModalList[Caller]) {
      this.dialInModalList[Caller] = null;
    }
  }
}

function mapStateToProps(state) {
  return {
    loginStatus: state.loginStatus,
    whiteList: state.customerProtectionWhiteList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateCallCenter: (callCenter, status, event) => dispatch({
      type: ActionTypes.CALL_CENTER_UPDATE,
      callCenter,
      status,
      event,
    }),
  };
}

export default withApi(connect(mapStateToProps, mapDispatchToProps)(CallCenterDock));

CallCenterDock.contextType = MessageBox;
